import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import cre from "./Cres.module.css";
import { MdOutlineClose, MdOutlineDashboard } from "react-icons/md";
import { LuFileSliders } from "react-icons/lu";
import {} from "@ckeditor/ckeditor5-react";
import { CiSettings } from "react-icons/ci";
import { Link } from "react-router";

const CreateArticle = () => {
  const [textI, setTextI] = useState("");
  const [textone, setTextone] = useState("");
  const [texttwo, setTexttwo] = useState("");
  const [textiii, setTextiii] = useState("");
  const [modal, setModal] = useState(false);

  const [files, setFiles] = useState("");
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles?.length) {
      setFiles((previousFiles) => [
        ...previousFiles,
        ...acceptedFiles.map((file) =>
          Object.assign(file, { preview: URL.createObjectURL(file) })
        ),
      ]);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  console.log(files);
  const removeFile = (name) => {
    setFiles((files) => files.filter((file) => file.name !== name));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  if (modal) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }
  return (
    <div className={cre.cre}>
      <div className={cre.container}>
        <div className={cre.content}>
          <div className={cre.block}>
            <div className={cre.blocki}>
              <div className={cre.seci}>
                <div className={cre.icon}>
                  <MdOutlineDashboard className={cre.word} size={"1rem"} />

                  <h3 className={cre.word}>Dashboard</h3>
                </div>
                <div className={cre.icon}>
                  <LuFileSliders className={cre.wordi} size={"1rem"} />
                  <h3>Article Review</h3>
                </div>
              </div>
              <div className={cre.seciI}>
                <div className={cre.icon}>
                  <CiSettings className={cre.wordi} size={"1rem"} />
                  <h3>Settings</h3>
                </div>
                <div className={cre.icon}>
                  <h3>Logout</h3>
                </div>
              </div>
            </div>
            <div className={cre.blockii}>
              <div className={cre.secI}>
                <h3>Create an article</h3>
                <div className="div">
                  <button
                    onClick={toggleModal}
                    className={`${cre.button} ${
                      textI ? cre.buttonActive : cre.buttonDefault
                    }`}
                  >
                    Send for review
                  </button>

                  {modal && (
                    <div className="modal">
                      <div onClick={toggleModal} className={cre.overlay}></div>
                      <div className={cre.modalcontent}>
                        <h2>Article Successful</h2>
                        <p>
                          Article has been sent and is under review, please wait
                          for the reviewer to access and review your article.
                          You will be notified when your article is accepted
                        </p>

                        <button
                          className={cre.closemodal}
                          onClick={toggleModal}
                        >
                          Go to Dashboard
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className={cre.blockI}>
                <div className={cre.secII}>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    {isDragActive ? (
                      <p>Drop the files here ...</p>
                    ) : (
                      <div className={cre.load}>
                        <h4>Upload article image</h4>
                        <p>
                          Drag and drop file into the box or manually upload
                          from your device
                          <h4>click here</h4> to manually upload your file
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  {Array.isArray(files) &&
                    files.length > 0 &&
                    files.map((file, index) => (
                      <div key={file.name || index}>
                        {" "}
                        {/* Ensure a unique key */}
                        <ul>
                          <li>{file.name || "Unnamed File"}</li>
                        </ul>
                        {file.preview && (
                          <div className={cre.btnI}>
                            <div className={cre.btn}>
                              <img
                                src={file.preview}
                                alt={file.name || "File Preview"}
                              />
                              <button onClick={() => removeFile(file.name)}>
                                <MdOutlineClose />
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </div>
              <div className={cre.seciii}>
                <div className={cre.title}>
                  <h4>Title</h4>
                  <input
                    type="text"
                    onChange={(e) => setTextI(e.target.value)}
                  />
                </div>
                <div className={cre.box}>
                  <div className={cre.boxI}>
                    <h4>Article</h4>
                    <p>
                      Write your article in the box below, you can choose to
                      upload an article in .TXT format by clicking on the
                      Upload.txt . The article is meant to be review before
                      publishing.
                    </p>
                    <textarea
                      name=""
                      id=""
                      placeholder="The Article"
                    ></textarea>
                  </div>
                  <div className={cre.boxII}>
                    <div className={cre.boxi}>
                      <label htmlFor="">Category</label>
                      <input
                        type="text"
                        placeholder="Science"
                        name=""
                        onChange={(e) => setTexttwo(e.target.value)}
                        id=""
                      />
                    </div>
                    <div className={cre.boxi}>
                      <label htmlFor="">Author</label>
                      <input
                        type="text"
                        placeholder="Enter Author’s name"
                        name=""
                        onChange={(e) => setTextone(e.target.value)}
                        id=""
                      />
                    </div>
                    <div className={cre.boxi}>
                      <label htmlFor="">Category</label>
                      <input
                        type="text"
                        placeholder="Science"
                        name=""
                        onChange={(e) => setTextiii(e.target.value)}
                        id=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateArticle;
